module.exports = __webpack_public_path__ + "static/img/33м2.8c8e784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/nets/33м2.png
// module id = nKu3
// module chunks = 0